import ImgCalendarProvider from '@/components/ImgCalendarProvider';
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	Grid,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { useAddCalendarController } from './add-calendar-modal.controller';

interface IProps {
	isOpen: boolean;
	close: () => void;
}

export default function AddCalendarModal(props: IProps) {
	const { t, handleSyncGoogleClick, handleSyncMicrosoft } = useAddCalendarController(props);

	return (
		<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					<Heading size="md">{t('Add calendar')}</Heading>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody pb={8}>
					<Grid gap={6} gridTemplateColumns={{ base: 'auto', md: 'repeat(2, 1fr)' }}>
						<Card>
							<CardHeader>
								<Heading size="sm">{t('Google Calendar')}</Heading>
							</CardHeader>
							<CardBody>
								<Grid justifyContent="center" alignItems="center" mb={8}>
									<ImgCalendarProvider size="16" provider="GOOGLE" />
								</Grid>

								<Text>{t('Sync calendar from your Google account')}</Text>

								<Button w="full" colorScheme="primary" mt={4} onClick={handleSyncGoogleClick}>
									{t('Connect calendar')}
								</Button>
							</CardBody>
						</Card>

						<Card>
							<CardHeader>
								<Heading size="sm">{t('Microsoft Calendar')}</Heading>
							</CardHeader>
							<CardBody>
								<Grid justifyContent="center" alignItems="center" mb={8}>
									<ImgCalendarProvider size="16" provider="MICROSOFT" />
								</Grid>
								<Text>{t('Sync calendar from your Microsoft account')}</Text>

								<Button w="full" colorScheme="primary" mt={4} onClick={handleSyncMicrosoft}>
									{t('Connect calendar')}
								</Button>
							</CardBody>
						</Card>
					</Grid>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}
